import * as React from "react";
import { SVGProps } from "react";
const SvgTrashBin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 25h2V13h-2v12Zm-.7-19 11.8-2c.6-.1.9-.6.8-1.2-.1-.6-.6-.9-1.2-.8L10 4c-.6.1-.9.6-.8 1.2.1.5.6.9 1.1.8ZM19 25h2V13h-2v12Zm-4 0h2V13h-2v12ZM7 8c-.6 0-1 .4-1 1v20c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1H7Zm1 20V10h16v18H8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrashBin;
